import React from "react";
import { motion } from "framer-motion";
import { features } from "../constants/features";

const containerVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1, delayChildren: 0.1 } },
};
const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
};

const FeaturesSection = () => (
  <section id="features" className="bg-surface py-24 px-6 overflow-hidden">
    <div className="max-w-6xl mx-auto">
      {/* Header */}
      <motion.div
        className="text-center mb-16"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
      >
        <span className="inline-block mb-3 text-xs font-bold tracking-widest text-primary uppercase bg-primary/8 rounded-full px-4 py-1.5 border border-primary/20">
          Core Features
        </span>
        <h2 className="text-3xl font-extrabold text-brand-text mb-3">
          Everything You Need for Policy Compliance
        </h2>
        <p className="text-brand-muted max-w-xl mx-auto">
          A complete toolkit for legal teams, DPOs, and compliance professionals.
        </p>
      </motion.div>

      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        variants={containerVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.15 }}
      >
        {features.map((f) => (
          <motion.div
            key={f.title}
            variants={cardVariants}
            whileHover={{ y: -6, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            className={`group bg-white border border-surface-border rounded-2xl p-6 cursor-default transition-shadow hover:shadow-xl ${f.glow}`}
          >
            <motion.div
              whileHover={{ rotate: 8, scale: 1.15 }}
              transition={{ type: "spring", stiffness: 400 }}
              className={`w-11 h-11 rounded-xl ${f.iconBg} flex items-center justify-center mb-4`}
            >
              <f.Icon className={`w-5 h-5 ${f.iconColor}`} />
            </motion.div>
            <h3 className="font-bold text-brand-text mb-2">{f.title}</h3>
            <p className="text-sm text-brand-muted leading-relaxed">{f.desc}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default FeaturesSection;
